var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 196,
    viewBox: "0 0 326 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H326V186C326 191.523 321.523 196 316 196H10C4.47716 196 0 191.523 0 186V0Z",
    fill: "#EDF4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightblue);
export default __webpack_public_path__ + "static/media/lightblue.20dc8ca9d0c9123667b9e18edee1817e.svg";
export { ForwardRef as ReactComponent };